import {Serializable} from "../../libraries/util/Serializable";

export class Jwt implements Serializable {
	constructor(
		readonly startedAt: number,
		readonly expiresAt: number,
	) {
	}
	
	static deserialize(json: any): Jwt {
		return new Jwt(
			json.startedAt,
			json.expiresAt,
		);
	}
	
	serialize(): any {
		return {
			startedAt: this.startedAt,
			expiresAt: this.expiresAt,
		};
	}
}
